import { IUseChatProps, useInitChat, usePopStackMessage } from '../hooks/core';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetReducer } from '../reduxStore/actions/actions';

export type IChatInitProviderProps = React.PropsWithChildren<IUseChatProps>;

export const ChatInitProvider = ({
	children,
	...props
}: IChatInitProviderProps) => {
	useInitChat(props);

	usePopStackMessage();
	const dispatch = useDispatch();
	useEffect(() => {
		return () => {
			dispatch(resetReducer());
		};
	}, []);

	return <>{children}</>;
};
